module.exports = __webpack_public_path__ + "static/media/25UNHCR1.3556ce76.jpg";